/**
 * Creates a function that will be executed after the number of MS
 * if and only if there are not an additional call.
 * @param {Function} callback 
 * @param {Number} buffer 
 */
export function createBuffered(callback, buffer) {
  var timerId;

  return function (...params) {
    if (timerId) {
      clearTimeout(timerId);
    }

    timerId = setTimeout(function () {
      callback.apply(this, params);
    }, buffer);
  };
}
